import { BaseEmpresa } from 'app/modulos/base';
import { Categoria } from '../categoria/categoria';
import { Unidade } from '../unidade/unidade';

export class Item extends BaseEmpresa {
  codigo: string;
  nome: string;
  descricao: string;
  situacao: ItemSituacao;
  medida: string;
  imagem: string;
  atributos: string[];
  favorito: boolean;
  estrela: boolean;
  fracionamento: boolean;
  ordem: number | null;
  categoria: Categoria;
  tipo = ItemTipo.Produto;
  valor: number;
  promocao: string;
  montagem: boolean = false;
  categoriaCodigo: string;
  alergenos: number[];
  composicao?: Composicao;
  montagemBloco?: string;
  montagemTipo?: ComposicaoTipo;
  montagemGrupoTipo?: ComposicaoGrupoTipo;
  montagemGrupo?: number;
  quantidade:number = 1;
  observacoes: string = "";
}

export enum ItemSituacao {
  Ativo = 1,
  Suspenso = 40,
  Desativado = 90,
}

export enum ItemTipo {
  Produto = 10,
  Insumo = 11,
  Composicao = 12,
  Fabricacao = 20,
  Beneficiamento = 30,
  Perda = 90,
  Servico = 110,
  Gorjeta = 150,
  Hora = 160,
  Couvert = 170,
  Permanencia = 180,
  TaxaDeServico = 200,
  TaxaDeEntrega = 210,
}

export const ItemTipoMap = new Map<ItemTipo, string>([
  [ItemTipo.Produto, 'Produto'],
  [ItemTipo.Insumo, 'Insumo'],
  [ItemTipo.Composicao, 'Composição'],
  [ItemTipo.Fabricacao, 'Fabricação'],
  [ItemTipo.Beneficiamento, 'Beneficiamento'],
  [ItemTipo.Perda, 'Perda'],
  [ItemTipo.Servico, 'Serviço'],
  [ItemTipo.Hora, 'Hora trabalhada'],
  [ItemTipo.Gorjeta, 'Gorjeta'],
  [ItemTipo.Couvert, 'Couvert'],
  [ItemTipo.Permanencia, 'Permanência'],
  [ItemTipo.TaxaDeServico, 'Taxa de Serviço'],
  [ItemTipo.TaxaDeEntrega, 'Taxa de Entrega'],
]);

export enum ItemAlergeno {
  Trigo = 10,
  Centeio = 20,
  Cevada = 30,
  Aveia = 40,
  Espelta = 50,
  Kamut = 60,
  Crustaceos = 70,
  Ovos = 80,
  Peixes = 90,
  Amendoim = 100,
  Soja = 110,
  Leite = 120,
  Amendoas = 130,
  Avelas = 140,
  CastanhasDeCaju = 150,
  CastanhasDoPara = 160,
  Nozes = 170,
  SodioElevado = 180,
}

export const ItemAlergenoMap = new Map<ItemAlergeno, string>([
  [ItemAlergeno.Trigo, 'Trigo'],
  [ItemAlergeno.Centeio, 'Centeio'],
  [ItemAlergeno.Cevada, 'Cevada'],
  [ItemAlergeno.Aveia, 'Aveia'],
  [ItemAlergeno.Espelta, 'Espelta'],
  [ItemAlergeno.Kamut, 'Kamut'],
  [ItemAlergeno.Crustaceos, 'Crustáceos'],
  [ItemAlergeno.Ovos, 'Ovos'],
  [ItemAlergeno.Peixes, 'Peixes'],
  [ItemAlergeno.Amendoim, 'Amendoim'],
  [ItemAlergeno.Soja, 'Soja'],
  [ItemAlergeno.Leite, 'Leite'],
  [ItemAlergeno.Amendoas, 'Amêndoas'],
  [ItemAlergeno.Avelas, 'Avelãs'],
  [ItemAlergeno.CastanhasDeCaju, 'Castanhas de caju'],
  [ItemAlergeno.CastanhasDoPara, 'Castanhas do Pará'],
  [ItemAlergeno.Nozes, 'Nozes'],
  [ItemAlergeno.SodioElevado, 'Sódio elevado'],
]);

export class ItemC extends BaseEmpresa {
  codigo: string;
  nome: string;
  // Foto da opcao do combo: o `cardapio/item` ja manda em `composicaoGrupoItens[].item`.
  imagem?: string;
}

export class Composicao extends BaseEmpresa {
  codigo: string;
  situacao: ComposicaoSituacao;
  tipo: ComposicaoTipo;
  item: ItemC;
  unidade: Unidade;
  fator: number;
  observacoes: string;
  composicaoGrupos: ComposicaoGrupo[];
  composicaoObservacoes: ComposicaoObservacao[];
}

export enum ComposicaoSituacao {
  Ativa = 1,
  Suspensa = 50,
  Desativada = 90,
}

export enum ComposicaoTipo {
  Montagem = 10,
  Insumo = 20,
  Beneficiamento = 30,
  Fabricacao = 40,
}

export enum ComposicaoAcao {
  Incluir = 10,
  //Editar = 20,
  Excluir = 30,
}

export class ComposicaoGrupo {
  situacao: ComposicaoSituacao;
  nome: string;
  tipo: ComposicaoGrupoTipo;
  ordem: number;
  minimo: number;
  maximo: number;
  valor: number;
  composicaoGrupoItens: ComposicaoGrupoItem[];
}

export enum ComposicaoGrupoTipo {
  Acompanhamento = 5,
  Opcional = 10,
  Adicional = 20,
  Complemento = 30,
}

export class ComposicaoGrupoItem {
  situacao: ComposicaoSituacao;
  item: ItemC;
  unidade: Unidade;
  quantidade: number;
  fator: number;
  minimo: number;
  maximo: number;
  valor: number;
  imprimir: boolean;
}

export class ComposicaoObservacao {
  situacao: ComposicaoSituacao;
  nome: string;
  acao: ComposicaoAcao;
  item: ItemC;
}